<template>
  <div class="footers-container">
    <footer
      id="l-footerLayout"
      class="footer"
    >
      <div class="l-bigContainer">
        <div class="l-contentContainer">
          <div class="l-largeur90p ">
            <div class="row">
              <slot name="getStarted">
                <div
                  id="footerGetStarted"
                  class="col-sm-4 col-lg-3"
                  v-if="getStartedLinks.length > 0"
                >
                  <h4>{{ i18n[locale].getStarted }}</h4>
                  <a
                    rel="external"
                    target="_blank"
                    v-for="link in getStartedLinks"
                    :key="link"
                    :href="i18n[locale][link].url"
                    v-html="i18n[locale][link].title"
                    data-gtm-event="nfb_menu"
                    data-gtm-nfb_detail="footer"
                  />
                </div>
              </slot>

              <slot name="resources">
                <div
                  id="footerGetHelp"
                  class="col-sm-4 col-lg-3"
                  v-if="resourcesLinks.length > 0"
                >
                  <h4>{{ i18n[locale].resources }}</h4>
                  <a
                    rel="external"
                    target="_blank"
                    v-for="link in resourcesLinks"
                    :key="link"
                    :href="i18n[locale][link].url"
                    v-html="i18n[locale][link].title"
                    data-gtm-event="nfb_menu"
                    data-gtm-nfb_detail="footer"
                  />
                </div>
              </slot>

              <slot name="more">
                <div
                  id="footerMore"
                  class="col-sm-4 col-lg-3"
                  v-if="moreLinks.length > 0"
                >
                  <h4>{{ i18n[locale].more }}</h4>
                  <a
                    rel="external"
                    target="_blank"
                    v-for="link in moreLinks"
                    :key="link"
                    :href="i18n[locale][link].url"
                    v-html="i18n[locale][link].title"
                    data-gtm-event="nfb_menu"
                    data-gtm-nfb_detail="footer"
                  />
                </div>
              </slot>

              <slot name="connect">
                <div
                  id="footerConnect"
                  class="social col-sm-12 col-lg-3"
                  v-if="connectLinks.length > 0"
                >
                  <h4>{{ i18n[locale].connect }}</h4>
                  <a
                    rel="external"
                    target="_blank"
                    v-for="link in connectLinks"
                    :key="link"
                    :href="i18n[locale][link].url"
                    v-html="i18n[locale][link].title"
                    data-gtm-event="nfb_menu"
                    data-gtm-nfb_detail="footer"
                  />
                </div>
              </slot>

              <slot name="secondary">
                <div
                  class="creditsSecondaryLinks col-sm-12"
                  v-if="secondaryLinks.length > 0"
                >
                  <div>
                    <a
                      :href="i18n[locale].canadaGovWebsite.url"
                      target="_blank"
                      id="canadaLogo"
                      data-gtm-event="nfb_menu"
                      data-gtm-nfb_detail="footer"
                      :title="i18n[locale].canadaGovWebsite.title"
                    >
                      <img
                        src="./../../../assets/logo-canada.svg"
                        alt="Canada"
                      >
                    </a>
                    © <span v-html="currentYear" />&#32;
                    <template
                      v-for="(link, index) in secondaryLinks"
                      :key="`${link}-link`"
                    >
                      <a
                        rel="nofollow external"
                        target="_blank"
                        :href="i18n[locale][link].url"
                        v-html="i18n[locale][link].title"
                        data-gtm-event="nfb_menu"
                        data-gtm-nfb_detail="footer"
                      />
                      &#32;<span
                        v-if="index < secondaryLinks.length - 1"
                        :key="`${link}-sep`"
                        class="sep"
                      >|</span>
                    </template>
                  </div>
                </div>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import enTranslations from './../../../i18n/en_CA/footer.json'
import frTranslations from './../../../i18n/fr_CA/footer.json'

export default {
  name: 'LayoutFooter',
  props: {
    locale: {
      type: String,
      default: 'en'
    },
    i18n: {
      type: Object,
      default: () => ({
        en: enTranslations,
        fr: frTranslations
      })
    },
    getStartedLinks: {
      type: Array,
      default: () => ([
        'newsletter',
        'apps',
        'events'
      ])
    },
    resourcesLinks: {
      type: Array,
      default: () => ([
        'helpCentre',
        'contactUs',
        'createWithUs',
        'organizeWithUs',
        'mediaSpace',
      ])
    },
    moreLinks: {
      type: Array,
      default: () => ([
        'blog',
        'distribution',
        'production',
        'education',
        'archives'
      ])
    },
    connectLinks: {
      type: Array,
      default: () => ([
        'facebook',
        'twitter',
        'vimeo',
        'youtube',
        'instagram'
      ])
    },
    secondaryLinks: {
      type: Array,
      default: () => ([
        'nfb',
        'institutionalWebsite',
        'accessibility',
        'notices',
        'privacy',
        'jobs'
      ])
    }
  },
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="less">
@import (reference) "./../../../less/shared/utilities.less";
@import "@{frontend_static_less}/public/layout/footer.less";
#l-footerLayout {
  span {
    margin-right: 0.2em;
    margin-left: 0.2em;
  }
}
</style>
